import { render, staticRenderFns } from "./VersionDialogTip.vue?vue&type=template&id=6978c710&scoped=true"
import script from "./VersionDialogTip.vue?vue&type=script&lang=js"
export * from "./VersionDialogTip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6978c710",
  null
  
)

export default component.exports